import React, { Fragment, PureComponent } from "react";
import { Link } from "react-router-dom";
import Recaptcha from "react-google-invisible-recaptcha";
import { config, server, RECAPTCHA_KEY } from "../env";
import { getOrderedStringArray } from "../helper/helper";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../components/Loader";

class Home extends PureComponent {
  state = {
    stats: {},
    loader: "",
    currencies: [],
    fromCurrency: "BTC",
    toCurrency: "ETH",
    fromPrecision: 8,
    transactionType: "fixed",

    // converted prices
    fromQty: 0.010863,
    convertedPrice: {},

    // extra vars
    isLoaded: false,
    onChangeLoader: false,
    message: "",
  };
  notify = (message, type) => {
    toast(message, { type, theme: "colored" });
  };

  componentDidMount = async () => {
    if(window.location.search.indexOf("features") != -1) document.getElementById("feat_sec").scrollIntoView();
    this.readCurrencies();
    const { fromCurrency, toCurrency, fromQty, transactionType } = this.state;
    this.readPrices(fromCurrency, toCurrency, fromQty, transactionType);
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  // change transaction type
  onChangeTransactionType = async (transactionType) => {
    this.setState({
      onChangeLoader: true,
    });
    const { fromCurrency, fromQty, toCurrency } = this.state;
    this.setState({ transactionType, onChangeLoader: true });

    await this.readPrices(fromCurrency, toCurrency, fromQty, transactionType);
    await this.validatePrices();
    await this.setState({ onChangeLoader: false });
  };

  readCurrencies = async () => {
    await axios.get(`${server}/v1/currency/read`).then((res) => {
      this.setState({
        currencies: getOrderedStringArray(res.data.payload.data),
      });
    });
  };

  readPrices = async (fromCurrency, toCurrency, fromQty, type) => {
    await axios
      .post(`${server}/v1/currency/rates`, {
        fromCurrency,
        toCurrency,
        fromQty,
        type,
      })
      .then((res) => {
        this.setState({
          convertedPrice:
            res.data.payload.code === 0 ? res.data.payload.data : {},
          isLoaded: true,
        });
      })
      .catch((err) => {
        console.log(err);
        this.notify("Invalid values or address", "error");
      });
    return;
  };

  validatePrices = () => {
    const { fromCurrency, fromQty, toQty, toCurrency, convertedPrice } =
      this.state;
    if (this.state.convertedPrice.from) {
      if (fromQty > this.state.convertedPrice.from.max) {
        this.notify(
          `Max amount is ${convertedPrice.from.max} for ${fromCurrency}`,
          "error"
        );
      } else if (fromQty < this.state.convertedPrice.from.min) {
        this.notify(
          `Min amount is ${convertedPrice.from.min} for ${fromCurrency}`,
          "error"
        );
      } else if (toQty > this.state.convertedPrice.to.max) {
        this.notify(
          `Max amount is ${convertedPrice.to.max} for ${toCurrency}`,
          "error"
        );
      } else if (toQty < this.state.convertedPrice.to.min) {
        this.notify(
          `Min amount is ${convertedPrice.to.min} for ${toCurrency}`,
          "error"
        );
      } else {
        this.setState({
          message: "",
        });
      }
    }
  };

  fromQtyChange = async (e) => {
    const { fromCurrency, toCurrency, transactionType } = this.state;

    var fromQty = e.target.value;
    await this.setState({
      fromQty: e.target.value,
      onChangeLoader: true,
    });

    await this.readPrices(fromCurrency, toCurrency, fromQty, transactionType);
    await this.validatePrices();
    await this.setState({ onChangeLoader: false });
  };

  // swap currencies
  swapCurrencies = async () => {
    const { fromCurrency, toCurrency, fromQty, transactionType } = this.state;
    const temp = fromCurrency;
    await this.setState({ fromCurrency: toCurrency, toCurrency: temp });
    await this.readPrices(toCurrency, fromCurrency, fromQty, transactionType);
    await this.validatePrices();
  };

  // on change form currency
  onChangeFromCurrency = async (e) => {
    await this.setState({
      fromCurrency: e.target.value,
      onChangeLoader: true,
    });
    const { fromQty, toCurrency, transactionType } = this.state;
    await this.readPrices(e.target.value, toCurrency, fromQty, transactionType);
    await this.validatePrices();
    await this.setState({ onChangeLoader: false });
  };

  // on change to currency
  onChangeToCurrency = async (e) => {
    const toCurrency = e.target.value;
    await this.setState({ toCurrency, onChangeLoader: true });
    const { fromCurrency, fromQty, transactionType } = this.state;
    await this.readPrices(fromCurrency, toCurrency, fromQty, transactionType);
    await this.validatePrices();
    await this.setState({ onChangeLoader: false });
  };

  // check user access
  checkAccess = async () => {
    var status = false;
    await axios
      .get(`${server}/v1/auth/access`, config)
      .then((res) => {
        status = true;
      })
      .catch((err) => {});
    return status;
  };

  // create order
  createOrder = async (e) => {
    e.preventDefault();

    // check user access
    const access = await this.checkAccess();

    var configs;
    if (!access)
      configs = {
        headers: {},
      };
    else configs = config;

    // loader
    await this.setState({ loader: <Loader /> });

    await this.recaptcha.execute();

    const { fromCurrency, toCurrency, fromQty, transactionType } = this.state;
    const params = {
      fromCurrency,
      toCurrency,
      fromQty,
      type: transactionType,
      memo: "abc",
      address: e.target.address.value,
      "g-recaptcha-response": this.state.reCaptcha,
    };
    await axios
      .post(`${server}/v1/order/create`, params, configs)
      .then((res) => {
        if (params.type === "float") {
          localStorage.setItem("timeLeft", 1800);
        } else {
          localStorage.setItem("timeLeft", 600);
        }
        const { orderId } = res.data.payload;
        window.location.href = "/order/" + orderId;
      })
      .catch((err) => {
        console.log(err);
        this.notify(err.response.data.detail, "error");
        this.setState({
          loader: "",
        });
      });
  };

  onResolved = () => {
    this.setState({ reCaptcha: this.recaptcha.getResponse() });
  };

  render() {
    const { currencies, fromCurrency, toCurrency, fromQty, loader } =
      this.state;
    const { transactionType, convertedPrice, onChangeLoader, message } =
      this.state;

    var toCurrencyName = toCurrency;
    if (currencies.length > 0) {
      toCurrencyName = currencies.filter(
        (currency) => currency.currency === toCurrency
      )[0].name;
    }
    return (
      <Fragment>
        <section className="home_hero_section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="hero_txt">
                  {/* <h6>
                    <span>NEW</span> Buy Prepaid visa debit card with crypto
                    now! <i className="fa fa-angle-right"></i>
                  </h6> */}
                  {/* <br /> */}
                  <h1>
                    The Lighting Fast <br />
                    Cryptocurrency Exchange
                  </h1>
                </div>
              </div>
            </div>
            <form onSubmit={this.createOrder}>
              <div className="row justify-content-center">
                <div className="col-lg-10">
                  <div className="hero_frm_wrap">
                    <div className="exchange_top_wrap">
                      <div className="echange_lft">
                        <div className="echange_input">
                          <input
                            type="text"
                            defaultValue={fromQty}
                            onChange={this.fromQtyChange}
                            step="0.00000001"
                          />
                          <select
                            name="fromCurrency"
                            id="fromCurrency"
                            onChange={this.onChangeFromCurrency}
                            className="pl-0"
                            style={{
                              maxWidth: "100px",
                            }}
                          >
                            {currencies.map((currency) => (
                              <option
                                value={currency.currency}
                                key={currency.currency}
                                selected={currency.currency === fromCurrency}
                              >
                                {currency.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <p>
                          1 {fromCurrency} ≈{" "}
                          {Object.keys(convertedPrice).length > 0
                            ? convertedPrice.from.rate
                            : ""}{" "}
                          {toCurrency} | $
                          {Object.keys(convertedPrice).length > 0
                            ? convertedPrice.from.usd
                            : 0}{" "}
                        </p>
                      </div>
                      <div className="echange_centr">
                        {onChangeLoader ? (
                          <Loader className="text-white" />
                        ) : (
                          <img
                            src="images/arows.svg"
                            alt="a"
                            className="img-fluid rt-90"
                            onClick={this.swapCurrencies}
                          />
                        )}
                      </div>
                      <div className="echange_lft echange_rgt">
                        <div className="echange_input">
                          <select
                            name="toCurrency"
                            id="toCurrency"
                            onChange={this.onChangeToCurrency}
                            className="pl-0"
                            style={{
                              maxWidth: "100px",
                            }}
                          >
                            {currencies.map((currency) => (
                              <option
                                value={currency.currency}
                                key={currency.currency}
                                selected={currency.currency === toCurrency}
                              >
                                {currency.name}
                              </option>
                            ))}
                          </select>
                          <input
                            type="text"
                            value={
                              Object.keys(convertedPrice).length > 0
                                ? convertedPrice.to.amount
                                : ""
                            }
                          />
                        </div>
                        <p>
                          1 {toCurrency} ≈{" "}
                          {Object.keys(convertedPrice).length > 0
                            ? convertedPrice.to.rate
                            : ""}{" "}
                          {fromCurrency} | $
                          {Object.keys(convertedPrice).length > 0
                            ? convertedPrice.to.usd
                            : 0}{" "}
                        </p>
                      </div>
                    </div>
                    <div className="middle_input_wrap">
                      <input
                        type="text"
                        placeholder={`Enter ${toCurrencyName} address`}
                        name="address"
                        className="form-control text-white"
                        required
                      />
                      {/* <img
                        src="images/box_2.svg"
                        alt="Power"
                        className="img-fluid"
                      /> */}
                    </div>
                    <div className="middle_inpt_wrap">
                      <Link
                        to="#"
                        className={transactionType === "fixed" ? "active" : ""}
                        onClick={() => this.onChangeTransactionType("fixed")}
                      >
                        Fixed Rate (1.0%)
                      </Link>
                      <Link
                        to="#"
                        className={transactionType === "float" ? "active" : ""}
                        onClick={() => this.onChangeTransactionType("float")}
                      >
                        Float Rate (0.5%)
                      </Link>
                    </div>
                    <div className="stand_for">
                      <a href="#faqOne">What does this stand for?</a>
                    </div>
                    <div className="exchange_btn">
                      <button type="submit" className="btn btn_submit">
                        Exchange Now {loader}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </section>

        <section className="why_choice" id="feat_sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="common_heading">
                  <h2>
                    Why Choose <span>CoinChange ?</span>
                  </h2>
                  <p>
                  CoinChange takes pride in its ability to be a high end crypto exchange for its customers.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3">
                <div className="feat_box_wrap feat_mt50">
                  <img
                    src="images/feat_icon.svg"
                    alt="Feature icons"
                    className="img-fluid"
                  />
                  <h5>Lowest Fees</h5>
                  <p>
                  CoinChange only takes .05% - 1% in fees, while other exchanges can reach 2-5%.

                  </p>
                </div>
                <div className="feat_box_wrap">
                  <img
                    src="images/feat_icon.svg"
                    alt="Feature icons"
                    className="img-fluid"
                  />
                  <h5>30+ Assets</h5>
                  <p>
                  We make sure to give our users a very wide variety of well established and secure tokens. 
                  </p>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="feat_box_wrap">
                  <img
                    src="images/feat_icon.svg"
                    alt="Feature icons"
                    className="img-fluid"
                  />
                  <h5>No Deposits</h5>
                  <p>
                  Our service is a direct exchange, there is no process that requires a deposit before a transfer. 
                  </p>
                </div>
                <div className="feat_box_wrap">
                  <img
                    src="images/feat_icon.svg"
                    alt="Feature icons"
                    className="img-fluid"
                  />
                  <h5>No Registration</h5>
                  <p>
                   While having a secure account with us is certainly available for users, we know that privacy is important and make it optional.

                  </p>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="feat_box_wrap feat_mt50">
                  <img
                    src="images/feat_icon.svg"
                    alt="Feature icons"
                    className="img-fluid"
                  />
                  <h5>24/7 Support</h5>
                  <p>
                  24/7 we listen to you, assist you, and make sure your questions do not go unanswered.
                  </p>
                </div>
                <div className="feat_box_wrap">
                  <img
                    src="images/feat_icon.svg"
                    alt="Feature icons"
                    className="img-fluid"
                  />
                  <h5>$3.3mil+ Exchanged</h5>
                  <p>
                  We take pride in being able to provide our service to this extent to our loyal users.
                  </p>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="feat_box_wrap">
                  <img
                    src="images/feat_icon.svg"
                    alt="Feature icons"
                    className="img-fluid"
                  />
                  <h5>No Hassle</h5>
                  <p>
                  CoinChange gets right to the point. We won't waste your precious time and will keep you satisfied with our service.

                  </p>
                </div>
                <div className="feat_box_wrap">
                  <img
                    src="images/feat_icon.svg"
                    alt="Feature icons"
                    className="img-fluid"
                  />
                  <h5>Same Currency Exchanges</h5>
                  <p>
                  We offer exchanges with a currency to the same currency for any user who so desires.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="faq_section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="common_heading">
                  <h2>
                    Frequently Asked <span>Questions</span>
                  </h2>
                  <p>
                  Before heading over to our dedicated support, see if your question is answered below!
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="faq_txt_wrap">
                  <div className="bs-example">
                    <div className="accordion" id="faqSeq">
                      <div className="card">
                        <div className="card-header" id="faqOne">
                          <h2 className="mb-0">
                            <button
                              type="button"
                              className="btn btn-link"
                              data-toggle="collapse"
                              data-target="#collapseOne"
                            >
                              {" "}
                              <span>
                              What is a fixed rate?
                              </span>{" "}
                              <i className="fa fa-plus"></i>
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapseOne"
                          className="collapse"
                          aria-labelledby="faqOne"
                          data-parent="#faqSeq"
                        >
                          <div className="card-body">
                            <p>
                            If you choose a fixed rate, you will recieve the price you see at the point of initiating a transaction that will be fixed for a 10 minute period. You will be paying a 1% Fee total for this.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="faqTwo">
                          <h2 className="mb-0">
                            <button
                              type="button"
                              className="btn btn-link"
                              data-toggle="collapse"
                              data-target="#collapseTwo"
                            >
                              {" "}
                              <span>
                              What is a float rate?
                              </span>{" "}
                              <i className="fa fa-plus"></i>
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapseTwo"
                          className="collapse"
                          aria-labelledby="faqTwo"
                          data-parent="#faqSeq"
                        >
                          <div className="card-body">
                            <p>
                            If you choose a float rate, the exchange rate is finally set when your transaction receives the necessary number of blockchain network confirmations. You pay from 0.4% - 0.5% as fees.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="faqThree">
                          <h2 className="mb-0">
                            <button
                              type="button"
                              className="btn btn-link collapsed"
                              data-toggle="collapse"
                              data-target="#collapseThree"
                            >
                              {" "}
                              <span>
                              How can I track my order?
                              </span>{" "}
                              <i className="fa fa-plus"></i>{" "}
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapseThree"
                          className="collapse"
                          aria-labelledby="faqThree"
                          data-parent="#faqSeq"
                        >
                          <div className="card-body">
                            <p>
                            You can track your order my saving the order ID or the link, otherwise you can register and the order ID will be saved in your orders.

                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="faqThreea">
                          <h2 className="mb-0">
                            <button
                              type="button"
                              className="btn btn-link collapsed"
                              data-toggle="collapse"
                              data-target="#collapseThreea"
                            >
                              {" "}
                              <span>
                              Is CoinChange user data saved?
                              </span>{" "}
                              <i className="fa fa-plus"></i>{" "}
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapseThreea"
                          className="collapse"
                          aria-labelledby="faqThreea"
                          data-parent="#faqSeq"
                        >
                          <div className="card-body">
                            <p>
                            We log absolutely no user data if you exchange as a guest. If you chose to register an account, we log the email ID of the account only to remove spam accounts.

                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="faqThreeas">
                          <h2 className="mb-0">
                            <button
                              type="button"
                              className="btn btn-link collapsed"
                              data-toggle="collapse"
                              data-target="#collapseThreeas"
                            >
                              {" "}
                              <span>
                              What can I do to speed up the transaction?
                              </span>{" "}
                              <i className="fa fa-plus"></i>{" "}
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapseThreeas"
                          className="collapse"
                          aria-labelledby="faqThreeas"
                          data-parent="#faqSeq"
                        >
                          <div className="card-body">
                            <p>
                            Each transaction in the blockchain has a price, which is a commission for those who participate in the maintenance of the blockchain network. The more contribute toward the network fee, the faster blockchain will process the transaction. This network fee is usually displayed automatically in your wallet.

                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="faqThreeasv">
                          <h2 className="mb-0">
                            <button
                              type="button"
                              className="btn btn-link collapsed"
                              data-toggle="collapse"
                              data-target="#collapseThreeasv"
                            >
                              <span>
                              Why is a currency I have exchanged not available anymore?  
                              </span>{" "}
                              <i className="fa fa-plus"></i>{" "}
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapseThreeasv"
                          className="collapse"
                          aria-labelledby="faqThreeasv"
                          data-parent="#faqSeq"
                        >
                          <div className="card-body">
                            <p>
                            Sometimes CoinChange will temporarily remove a currency from our service while our developers fix bugs. If there are any issues or bugs we will ensure that our users do not have to experience them by resolving the issue and returning the currency to our exchange.

                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="faqThreeasx">
                          <h2 className="mb-0">
                            <button
                              type="button"
                              className="btn btn-link collapsed"
                              data-toggle="collapse"
                              data-target="#collapseThreeasx"
                            >
                              {" "}
                              <span>
                              What is the max amount I can transfer?
                              </span>{" "}
                              <i className="fa fa-plus"></i>{" "}
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapseThreeasx"
                          className="collapse"
                          aria-labelledby="faqThreeasx"
                          data-parent="#faqSeq"
                        >
                          <div className="card-body">
                            <p>
                            Depending on the currency you have selected, you will be notified when you have reached the limit on an individual transfer.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="faqThreeasbfgkr">
                          <h2 className="mb-0">
                            <button
                              type="button"
                              className="btn btn-link collapsed"
                              data-toggle="collapse"
                              data-target="#collapseThreeasbfgkr"
                            >
                              {" "}
                              <span>
                              Where can I see more credible sources of your exchange?
                              </span>
                              <i className="fa fa-plus"></i>
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapseThreeasbfgkr"
                          className="collapse"
                          aria-labelledby="faqThreeasbfgkr"
                          data-parent="#faqSeq"
                        >
                          <div className="card-body">
                            <p>
                            Please look through our Discord. We provide vouches of real costumers who will discuss with you if you reach out to them.

                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="faqFour">
                          <h2 className="mb-0">
                            <button
                              type="button"
                              className="btn btn-link collapsed"
                              data-toggle="collapse"
                              data-target="#collapsefaqFour"
                            >
                              {" "}
                              <span>
                              Does CoinChange offer livechat? 
                              </span>{" "}
                              <i className="fa fa-plus"></i>{" "}
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapsefaqFour"
                          className="collapse"
                          aria-labelledby="faqFour"
                          data-parent="#faqSeq"
                        >
                          <div className="card-body">
                            <p>
                            Yes! Please talk to our customer support team via livechat so they can assist with whatever you need at lightning speed.                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="faq_more_bttn">
                  <p>Got More Questions ?</p>
                  <div className="faq_chat_box">
                    <h6>
                      {" "}
                      <img
                        src="images/dis.svg"
                        alt="Chat"
                        className="img-fluid"
                      />{" "}
                      Join Our Discord Server
                    </h6>
                    <a href="https://discord.gg/Whhpfx73BB" target="_blank">Chat Now</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <ToastContainer />
        <Recaptcha
          ref={(ref) => (this.recaptcha = ref)}
          sitekey={RECAPTCHA_KEY}
          onResolved={this.onResolved}
        />
      </Fragment>
    );
  }
}

export default Home;
